import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";

const RegFormPopup = ({ open, handleClose }) => {
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435, padding: '0 10px' } }}
      maxWidth="sm"
      // TransitionProps={{ onEntering: handleEntering }}
      open={open}
    >
      <DialogTitle>Requirements for Accreditation</DialogTitle>
      <DialogContent dividers>
        <ol>
          <li>Have a standard training Centre.</li>
          <li>
            Must Possess a minimum of three years’ experience as a skill
            trainer.{" "}
          </li>
          <li>
            Business premise must be a registered location (either CAC or Local
            Government Authorities).
          </li>
          <li>
            Educational qualification must be above secondary school and will be
            uploaded on the registration portal.
          </li>
          <li>Must be fluent in English Language.</li>
          <li>Non-Nigerians should show evidence of work permit.</li>
        </ol>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" autoFocus onClick={handleClose}>
          Agree & Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegFormPopup;
